import React from 'react';
import Modal from 'react-modal';
import styled from 'styled-components';
import { ButtonLink } from '@/styles/theme/default/buttons';
import {
  BodyFive,
  SubtitleTwo
} from '@/styles/theme/default/typography';
import Icon from '../../Icon';
// import useSale  from '@/hooks/useSale';
import {useSelector} from "react-redux";
import { gql, useQuery } from '@apollo/client';
import useSale from '@/hooks/useSale';

const Wrapper = styled.div`
  padding: 20px;

  .sale-details-title {
    margin-bottom: 20px;
  }

  .close-icon-container {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
  }

  .close-icon {
    cursor: pointer;
  }

  li {
    margin-bottom: 20px;
  }

  .btn-link-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 35px;

    .btn-link {
      width: 150px;
    }
  }
`;

function SaleDetailsPopup({ open, toggle }) {
  const { saleStage } = useSale();

  const user = useSelector(state => state.Auth.user);
  const isTrade = [2].includes(parseInt(user.role_id));
  // const isTrade = true;

  const SALE_DETAIL = gql`
    query saleDetail($stage: String, $audience: String!) {
      saleDetail(stage: $stage, audience: $audience) {
        id
        title
        body
        link_text
        link_url
      }
    }
  `;

  const { data } = useQuery(SALE_DETAIL, {
    variables: { stage: saleStage || null, audience: isTrade ? 'trade' : 'guest' }
  });

  const detail = data?.saleDetail;
  const fallbackBody = isTrade
    ? 'Offer valid for up to 30% off; 30% off select beds, 25% off all other categories. No code needed. Promotions cannot be combined or applied to past purchases. Promotions can only be applied to purchases on theinside.com. Offer applies to cart before shipping and tax. Select non-upholstered items are excluded from this promotion with the prices as marked: Accent & End Tables, Nightstands, Mattresses, Non-Upholstered Dining Chairs & Stools, Rugs.'
    : 'Offer valid for up to 25% off; 25% off select beds, 20% off all other categories. No code needed. Promotions cannot be combined or applied to past purchases. Promotions can only be applied to purchases on theinside.com. Offer applies to cart before shipping and tax. Select non-upholstered items are excluded from this promotion with the prices as marked: Accent & End Tables, Nightstands, Mattresses, Non-Upholstered Dining Chairs & Stools, Rugs.';
  const detailBody = detail?.body || fallbackBody;
  const detailTitle = detail?.title || '';
  const linkText = detail?.link_text || 'Shop Now';
  const linkUrl = detail?.link_url || '/collections/bestsellers';

  return (
    <Modal
      className="SaleDetailsModal"
      overlayClassName="ModalUfcOverlay"
      ariaHideApp={false}
      closeTimeoutMS={500}
      isOpen={open}
      onRequestClose={toggle}
    >
      <Wrapper>
        <div className="close-icon-container">
          <Icon
            onClick={toggle}
            className="close-icon"
            icon="ti-close-x"
            size={20}
            color="black"
          />
        </div>
        <div className="content">
          {/*<SubtitleTwo className="sale-details-title" bold>*/}
          {/*  {saleStage === 'regular' ?*/}
          {/*                  'SHOP THE END OF SUMMER SALE AND USE CODE AUGSALE23 TO SAVE 15% OFF ORDERS UNDER $499 OR 20% OFF ORDERS $499+.' :*/}
          {/*    (saleStage === 'surpriseExtension' ? 'Last chance to shop our End of Summer Sale. Use code AUGSALE23 to save 15% off orders under $499 or 20% off orders $499+.' : 'Last day to shop our End of Summer Sale. Use code AUGSALE23 to save 15% off orders under $499 or 20% off orders $499+.')*/}
          {/*                  }*/}
          {/*</SubtitleTwo>*/}
          {/* {detailTitle && (
            <SubtitleTwo className="sale-details-title" bold>
              {detailTitle}
            </SubtitleTwo>
          )} */}
          {detailBody && (
            <BodyFive dangerouslySetInnerHTML={{ __html: detailBody }} />
          )}
          <div className="btn-link-container">
            <ButtonLink
              dark={true}
              className="btn-link"
              to={linkUrl}
              onClick={toggle}
            >
              {linkText}
            </ButtonLink>
          </div>
        </div>
      </Wrapper>
    </Modal>
  );
}

export default SaleDetailsPopup;
